import { dataBoxSyncIPC, startOnceTest, updateDataBox } from "@/api/device/data-box"
import TnInput from "@/global/components/input/tn-input"
import TnMessage from "@/global/components/message"
import { DataBox } from "@/global/interface/device/data-box"
import { Button, Switch, message } from "antd"
import classNames from "classnames"
import { useEffect, useState } from "react"
import { ReactComponent as EditSvg } from '../icons/edit.svg';
import "./index.less"
import { getDateDetailName } from "@/global/utils/date-utils"
import { DATA_BOX_TYPE } from "@/enums/data-box-type"
// 正float正则匹配
const floatRegex = /^\d*\.?\d+$/;

const DataBoxStatus = {
    OFF: 0,     // 离线
    ON: 1,      // 正常
    ERROR: 2    // 异常
}
interface Iprops {
    data: DataBox
    setData: (e) => void
}
export default function DataBoxDefinePanel(props: Iprops) {

    const { data } = props

    const [isCodeEdit, setIsCodeEdit] = useState<boolean>(false)
    const [isImeiEdit, setIsImeiEdit] = useState<boolean>(false)
    const [isPeriodEdit, setIsPeriodEdit] = useState<boolean>(false)

    const [status, setStatus] = useState<number>(DataBoxStatus.OFF)

    const onCodeConfirm = (e) => {
        updateDataBox(data.id, { code: e }).then(res => {
            data.code = e
            props.setData({ ...data })
        }).finally(() => {
            setIsCodeEdit(false)
        })
    }

    const onImeiConfirm = (e) => {
        updateDataBox(data.id, { imei: e }).then(res => {
            data.imei = e
            props.setData({ ...data })
        }).finally(() => {
            setIsImeiEdit(false)
        })
    }

    const onPeriodConfirm = (e: string) => {
        if (!floatRegex.test(e)) {
            TnMessage.warning("输入非法！")
            return
        }
        let eNum = Number(e)
        eNum *= 1000
        updateDataBox(data.id, { period: eNum }).then(res => {
            data.period = eNum
            props.setData({ ...data })
        }).finally(() => {
            setIsPeriodEdit(false)
        })
    }

    useEffect(() => {
        if (data) {
            checkSensorStatus(data)
        }
    }, [data])

    // 判断设备状态
    const checkSensorStatus = (dataBox: DataBox) => {
        if (!dataBox?.start || !dataBox?.period) {
            setStatus(DataBoxStatus.OFF)
            return
        }
        let data = new Date(dataBox.lastMeasureTime).getTime()
        let nowTime = Date.now();
        let subValue = nowTime - data
        if (subValue < dataBox.period * 10) {
            setStatus(DataBoxStatus.ON)
        } else {
            setStatus(DataBoxStatus.ERROR)
        }
    }

    const onClickSyncIPC = () => {
        if (data.start) {
            message.warning("请先关闭采集")
            return
        }
        dataBoxSyncIPC(data.id).then(res => {
            if (res.data < 0) {
                message.warning(getWarningMessage(res.data))

            } else {
                message.success("同步成功")
            }
        })
    }

    const getWarningMessage = (status: number) => {
        switch (status) {
            case -1:
                return "工控机不存在";
            case -2:
                return "工控机未配置imei";
            case -3:
                return "对应工控机未建立连接";
            case -4:
                return "采集箱未关联摄像头";
            case -5:
                return "传感器未关联监测参数";
            case -6:
                return "向工控机发送数据失败";
            default:
                break;
        }
    }

    const onClickStartOneTest = () => {
        startOnceTest(data.id)
    }

    return (
        <div className="data-box-define-main">
            <div className="title">
                采集箱定义
            </div>
            <div className="data-box-detail">
                <div className="item">
                    <div className="label">
                        采集箱类型
                    </div>
                    <div className="value">
                        {data?.name}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        采集箱编号
                    </div>
                    <div className="value">
                        {!isCodeEdit ? (
                            <div className="code">
                                {data?.code}
                                <EditSvg className="edit-svg"
                                    onClick={() => {
                                        setIsCodeEdit(true)
                                    }}
                                />
                            </div>
                        ) : (
                            <TnInput
                                autoFocus={true}
                                defaultValue={data?.code || ""}
                                onBlur={(e) => { onCodeConfirm(e) }}
                                onPressEnter={(e) => { onCodeConfirm(e) }}
                            />
                        )}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        采集箱imei
                    </div>
                    <div className="value">
                        {!isImeiEdit ? (
                            <div className="code">
                                {data?.imei || "未设置imei"}
                                <EditSvg className="edit-svg"
                                    onClick={() => {
                                        if (data?.start) {
                                            TnMessage.warning("采集数据中，无法编辑")
                                            return
                                        }
                                        setIsImeiEdit(true)
                                    }}
                                />
                            </div>
                        ) : (
                            <TnInput
                                autoFocus={true}
                                defaultValue={data?.imei || ""}
                                onBlur={(e) => { onImeiConfirm(e) }}
                                onPressEnter={(e) => { onImeiConfirm(e) }}
                            />
                        )}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        采样间隔
                    </div>
                    <div className="value">

                        {!isPeriodEdit ? (
                            <div className="code">
                                {data?.period ? (data.period / 1000).toFixed(3) + " s" : "未设置间隔"}
                                <EditSvg className="edit-svg"
                                    onClick={() => {
                                        if (data?.start) {
                                            TnMessage.warning("采集数据中，无法编辑")
                                            return
                                        }
                                        setIsPeriodEdit(true)
                                    }}
                                />
                            </div>
                        ) : (
                            <TnInput
                                autoFocus={true}
                                defaultValue={data?.period ? (data.period / 1000).toFixed(3) : ""}
                                onBlur={(e) => { onPeriodConfirm(e) }}
                                onPressEnter={(e) => { onPeriodConfirm(e) }}
                            />
                        )}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        更新时间
                    </div>
                    <div className="value">
                        {data?.lastMeasureTime ? getDateDetailName(data.lastMeasureTime) : ""}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        运行状态
                    </div>
                    <div className="value">
                        <div className={classNames({
                            "status": true,
                            "status-off": !data?.isConnect,
                            "status-on": data?.isConnect,
                        })}>
                        </div>
                    </div>
                </div>
                {data?.type == DATA_BOX_TYPE.IPC && (
                    <>
                        <div className="item">
                            <div className="label">
                            </div>
                            <div className="value">
                                <Button size="small" onClick={() => {
                                    onClickSyncIPC()
                                }}>同步工控机</Button>
                            </div>
                        </div>
                        <div className="item">
                            <div className="label">
                            </div>
                            <div className="value">
                                <Button size="small" onClick={() => {
                                    onClickStartOneTest()
                                }}>进行一次测试</Button>
                            </div>
                        </div>
                    </>

                )}
            </div>
        </div>
    )
}